import React from "react";
import useUser from "./useUser";
import User from "./Components/User";

const UserIndex: React.FC = () => {
  const userProps = useUser();

  return <User />;
};
export default UserIndex;
